import Radio, { LabelPlacement } from '@zvuk-b2b/react-uikit/ui/Radio';
import { IVideoStream } from 'application/pages/PointsGroupsPage/types';
import React from 'react';
import VideoStreamPreviewItem from '../VideoStreamInfo/VideoStreamPreviewItem';

interface IChooseVideoStreamProps {
  videoStreams?: IVideoStream[];
  masterVideoStreamId?: string | number;
  setVideoStreamId: (id: string | number) => void;
}

export const ChooseVideoStream: React.FC<IChooseVideoStreamProps> = ({
  videoStreams,
  masterVideoStreamId,
  setVideoStreamId,
}) => (
  <div>
    {videoStreams?.map((it) => (
      <Radio
        key={it.id}
        elementId={`video_stream_${it.id}`}
        isChecked={it.id === masterVideoStreamId}
        labelPlacement={LabelPlacement.RIGHT}
        isStretch
        onChange={(value) => {
          if (value) {
            setVideoStreamId(it.id);
          }
        }}>
        <VideoStreamPreviewItem stream={it} />
      </Radio>
    ))}
  </div>
);
